import { BankTransferDetailsScreen } from '@/modules/payments/BankTransferDetailsScreen';

export default function BankTransferDetailsRoute() {
    return <BankTransferDetailsScreen />;
}
